import {
	styled
} from '@payright/web-components';

export const SCLoaderWrapper = styled.div`
  text-align: center;
  margin-top: 6em;
`;